(() => {
  const productHandle = '3-for-300-promotion';
  const productPage = document.querySelector(`product-info[data-product-handle="${productHandle}"]`);

  if (!productPage) return;

  let resetAfterCartUpdate = false;
  let reloadOnDrawerClose = false;

  productPage.addEventListener('theme:product:add', (event) => {
    const addButton = event.detail?.button;

    if (!addButton || !productPage.contains(addButton)) return;

    resetAfterCartUpdate = true;
  });

  const dispatchOptionChange = (input) => {
    input.dispatchEvent(new Event('input', {bubbles: true}));
    input.dispatchEvent(new Event('change', {bubbles: true}));
  };

  const resetEasifyOptions = () => {
    const optionSet = productPage.querySelector('.tpo_option-set-container');

    if (!optionSet) {
      reloadOnDrawerClose = true;
      return;
    }

    optionSet.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach((input) => {
      input.click();
    });

    optionSet
      .querySelectorAll('input.tpo_option-dropdown, input.tpo_hidden-checkbox, input.tpo_file-upload-input')
      .forEach((input) => {
        input.value = '';
        dispatchOptionChange(input);
      });

    optionSet.querySelectorAll('input[type="file"]').forEach((input) => {
      input.value = '';
      dispatchOptionChange(input);
    });

    const productForm = productPage.querySelector('product-form form');
    const quantityInput = productForm?.querySelector('[name="quantity"]');

    if (quantityInput) {
      quantityInput.value = '1';
      dispatchOptionChange(quantityInput);
    }

    window.setTimeout(() => {
      const hasSelections = Array.from(
        optionSet.querySelectorAll('input.tpo_option-dropdown, input.tpo_hidden-checkbox')
      ).some((input) => input.value !== '');

      reloadOnDrawerClose = hasSelections;
    }, 250);
  };

  document.addEventListener('theme:product:added', () => {
    if (!resetAfterCartUpdate) return;

    resetAfterCartUpdate = false;
    window.setTimeout(resetEasifyOptions, 0);
  });

  document.addEventListener('theme:cart-drawer:close', () => {
    if (!reloadOnDrawerClose) return;

    reloadOnDrawerClose = false;
    window.location.reload();
  });

  window.addEventListener('pageshow', (event) => {
    if ((!resetAfterCartUpdate && !reloadOnDrawerClose) || !event.persisted) return;

    resetAfterCartUpdate = false;
    reloadOnDrawerClose = false;
    window.location.reload();
  });
})();
